import { Component, Vue } from 'vue-property-decorator';

@Component
export default class RegresarButtonComponent extends Vue {
  public previousState(): void {
    this.$router.go(-1);
  }
}
